<template>
	<ul class="products">
		<li v-for="id in listProducts" @click="clickProduct(id)">
			<div class="img-wrap">
				<img :src="getImage(getFirstImage(products[id].images),160)" />
				<div class="price">{{getPrice(products[id].price)}}</div>
				<div v-if="selectMode" class="selector" :class="{'selected': value.indexOf(id) !== -1}"><span v-if="value.indexOf(id) !== -1">{{value.indexOf(id) + 1}}</span></div>
			</div>
		</li>
	</ul>
</template>

<script>
	import {mapState} from "vuex";
	import productHelpers from "@/mixins/productHelpers";
	import {removeItemFromArray} from "@/helperFunctions";

	export default {
		mixins:[productHelpers],
		data(){
			return {
				localValue: []
			}
		},
		computed: {
			...mapState('vorbasse', {
				products: 'products'
			}),
		},
		methods: {
			goToProduct(id)
			{
				this.$router.push("/boderne/produkt/" + id)
			},
			clickProduct(id)
			{
				if(this.selectMode){
					this.selectProduct(id)
				}else{
					this.goToProduct(id)
				}
			},
			selectProduct(id)
			{
				if(this.localValue.indexOf(id) === -1){
					this.localValue.push(id)
				}else{
					this.localValue= removeItemFromArray(this.localValue,id)
				}
				this.$emit('input',this.localValue);
			},
		},
		mounted()
		{
			this.localValue = this.value;
		},
		props: {
			value: {
				type: Array,
				default: function(){
					return [];
				}
			},
			selectMode: {
				type: Boolean,
				default: false
			},
			listProducts: {
				type: Array,
				required: true
			}
		},
		watch: {
			value(to){
				this.localValue = to;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.products{
		margin: 0px auto;
        padding: 15px 0px 150px;
		max-width: 368px;
		li{
			width: 50%;
			float: left;
			padding: 7px;
			list-style: none;
			.img-wrap{
				background: $white;
				padding: 5px;
				width: 170px;
				position: relative;
				cursor: pointer;
				img{
					display: block;
					max-width: 100%;
					min-height: 120px;
				}
				.price{
					font-size: 12px;
					font-weight: bold;
					color: $white;
					padding: 10px 20px;
					border-radius: 30px;
					background: $orange;
					position: absolute;
					left: 0px;
					bottom: 0px;
				}
				.selector{
					display: block;
					width: 46px;
					height: 46px;
					border-radius: 50%;
					background: $white;
					border: 2px solid $green;
					margin-left: 10px;
					font-size: 14px;
					font-weight: bold;
					text-align: center;
					line-height: 40px;
					position: absolute;
					bottom: -10px;
					left: 50%;
					margin-left: -22px;
					&.selected{
						background: $green;
						color: $white;
					}
				}
			}
			&:nth-child(6n+1){
				.img-wrap{
					transform: rotate(-7deg);
					.selector{
						transform: rotate(7deg);
					}
				}
			}
			&:nth-child(6n+2){
				.img-wrap{
					transform: rotate(4deg);
					.selector{
						transform: rotate(-4deg);
					}
				}
			}
			&:nth-child(6n+3){
				.img-wrap{
					transform: rotate(9deg);
					.selector{
						transform: rotate(-9deg);
					}
				}
			}
			&:nth-child(6n+4){
				.img-wrap{
					transform: rotate(-2deg);
					.selector{
						transform: rotate(2deg);
					}
				}
			}
			&:nth-child(6n+5){
				.img-wrap{
					transform: rotate(-3deg);
					.selector{
						transform: rotate(3deg);
					}
				}
			}
			&:nth-child(6n+6){
				.img-wrap{
					transform: rotate(12deg);
					.selector{
						transform: rotate(-12deg);
					}
				}
			}
		}
		&:after{
			display: block;
			content: "";
			clear: both;
		}
		@media(min-width: 768px){
			max-width: 736px;
			li{
				width: 25%;
			}
		}
		@media(min-width: 992px){
			max-width: 920px;
			li{
				width: 20%;
			}
		}
		@media(min-width: 1200px){
			max-width: 1104px;
			li{
				width: 16.66%;
			}
		}
	}

</style>
